import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { HOMEVISION_JOB_TYPE_SETTINGS_ACTION_TYPE } from 'store/system/actions';

const initialState = {};

const homeVisionJobTypeSettingsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case HOMEVISION_JOB_TYPE_SETTINGS_ACTION_TYPE.GET_HOMEVISION_JOB_TYPE_SETTINGS:
        return payload || initialState;

      case HOMEVISION_JOB_TYPE_SETTINGS_ACTION_TYPE.CREATE_HOMEVISION_JOB_TYPE_SETTING:
      case HOMEVISION_JOB_TYPE_SETTINGS_ACTION_TYPE.UPDATE_HOMEVISION_JOB_TYPE_SETTING:
        draft[payload.id] = payload;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default homeVisionJobTypeSettingsReducer;
